export interface SessionProperties {
  envId: string;
  projId: string;
  orgId: string;
}
